import Padding from '@/components/padding/Padding';
import { Link, Text } from '@chakra-ui/react';
import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import {
  IOS_APP_STORE_URL as APPLE_STORE_URL,
  ANDROID_PLAY_STORE_URL as GOOGLE_PLAY_URL,
} from '@/utils/appStoreRedirect';

const Footer = (): React.JSX.Element => {
  return (
    <Padding verticalPadding={10} backgroundColor="#16161f">
      <Text mb={4} fontSize="xl" color="white" style={{ fontFamily: 'Bebas Neue' }}>
        Documents
      </Text>
      <Link
        href="https://content.olympiq.co.uk/documents/Olympiq_Privacy_Policy.pdf"
        target="_blank"
        rel="noopener noreferrer"
        fontSize="sm"
        color="white"
        style={{ fontFamily: 'Lato' }}
      >
        Privacy Policy
      </Link>
      <br />
      <Link
        href="https://content.olympiq.co.uk/documents/Olympiq_Cookie_Policy.pdf"
        target="_blank"
        rel="noopener noreferrer"
        fontSize="sm"
        color="white"
        style={{ fontFamily: 'Lato' }}
      >
        Cookie Policy
      </Link>

      {/* Divider */}
      <hr className="border-white/20 my-8" />

      {/* Logo + name on left, app store buttons on right */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-wrap gap-3">
          <a
            href={APPLE_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-white/30 text-white text-sm hover:bg-white/10 transition-colors"
            style={{ fontFamily: 'Lato' }}
          >
            <FaApple className="text-lg" />
            App Store
          </a>
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-white/30 text-white text-sm hover:bg-white/10 transition-colors"
            style={{ fontFamily: 'Lato' }}
          >
            <FaGooglePlay className="text-base" />
            Google Play
          </a>
        </div>

        <span className="text-white/50 text-xs" style={{ fontFamily: 'Lato' }}>
          &copy; {new Date().getFullYear()} Olympiq. All rights reserved.
        </span>
      </div>
    </Padding>
  );
};

export default Footer;
